<template>
  <div
    :class="[
      'flex flex-col items-center justify-center w-full max-w-[512px] mx-auto text-center bg-cover bg-center',
      containerClass,
      sizeClasses.gap,
    ]"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <slot name="icon">
      <app-icon
        v-if="showIcon"
        :name="icon"
        variant="box"
        size="lg"
        class="drop-shadow-sm bg-white"
      />
    </slot>
    <div class="flex flex-col gap-1">
      <slot name="title">
        <h3 :class="['font-semibold', sizeClasses.title]">{{ title }}</h3>
      </slot>
      <slot name="description">
        <p :class="['text-gray-600 max-w-[354px]', sizeClasses.description]">{{ description }}</p>
      </slot>
    </div>
    <slot name="actions">
      <button
        v-if="clearBtnLabel"
        class="btn btn-lg btn-secondary"
        @click="emit('clear')"
      >
        {{ clearBtnLabel }}
      </button>
    </slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: String,
    default: 'md',
    validator(value) {
      return ['sm', 'md'].includes(value);
    },
  },
  containerClass: {
    type: String,
    default: 'py-16',
  },
  icon: {
    type: String,
    default: 'search',
  },
  title: {
    type: String,
    default: 'No data found',
  },
  description: {
    type: String,
    default: 'No data found, please try again later.',
  },
  clearBtnLabel: {
    type: String,
  },
  backgroundImage: {
    type: String,
    default: '/images/dots-pattern.svg',
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['clear']);

const sizeClasses = computed(() => {
  const classes = {
    sm: {
      gap: 'gap-4',
      title: 'text-base',
      description: 'text-sm',
    },
    md: {
      gap: 'gap-5',
      title: 'text-lg',
      description: 'text-sm',
    },
  }[props.size];

  return {
    gap: classes.gap,
    icon: classes.icon,
    title: classes.title,
    description: classes.description,
  };
});
</script>
